
import { useAuth } from "@/contexts/AuthContext";

export const useRolePermissions = () => {
  const { currentUserRole } = useAuth();

  const isAdmin = currentUserRole === 'admin';
  const isManager = currentUserRole === 'manager';
  const isStaff = currentUserRole === 'staff';

  const canManageClients = isAdmin || isManager;
  const canManageWorkoutTypes = isAdmin || isManager;
  const canManageUsers = isAdmin;
  const canManageSchedule = isAdmin || isManager;

  return {
    isAdmin,
    isManager,
    isStaff,
    canManageClients,
    canManageWorkoutTypes,
    canManageUsers,
    canManageSchedule,
    role: currentUserRole || 'staff'
  };
};
